export default __webpack_public_path__ + "static/media/img-0423-belarus-half-face.03a7657d.png";